import { j as json } from "../../../../../../chunks/index2.js";
import { h as handleRequest } from "../../../../../../chunks/utils.js";
import "firebase-admin";
import { U as UserCollection } from "../../../../../../chunks/firebase.js";
const ensureUserId = async (userDoc) => {
  const user = userDoc.data();
  if (userDoc.id.includes("@glimmr.com")) {
    await userDoc.ref.delete();
    await UserCollection().doc(user.id).set(user);
  }
};
const GET = handleRequest(async () => {
  const users = await UserCollection().get();
  const promises = users.docs.map(ensureUserId);
  await Promise.all(promises);
  return json({
    success: true
  });
});
export {
  GET
};
